import React, { useEffect, useState } from "react";
import {
  CustomButton2,
  CustomDropdownMultiSearch,
  CustomInput,
  CustomModal,
  CustomTimePiker,
  CustomView,
} from "../../../../../../components";
import { useFormik } from "formik";
import * as Yup from "yup";
import validations from "../../../../../../validations";
import { IUpdateStudent } from "../../../../../../types/student.interface";
import values from "../../../../../../values";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import api from "../../../../../../api";
import {
  ICompanyItem,
  IOnSearchUser,
} from "../../../../../../types/common.interface";
import utils from "../../../../../../utils";
import driverUpdateService from "../../../../../../api/method.put/common/driverUpdateService";
import convertPriceToNumber from "../../../../../../utils/convertPriceToNumber";
import successHandler from "../../../../../../utils/successHandler";
import errorHandler from "../../../../../../utils/errorHandler";
import Cookies from "js-cookie";
import constants from "../../../../../../values/constants";
import { transpileModule } from "typescript";

type Props = { service: any; isOpen: boolean; onClose: () => void ,allService:any};

const UpdateServicePrice = (props: Props) => {
  const { t } = useTranslation();

  const [dropDownErrors, setDropDownErrors] = React.useState<any>({
    parent: "",
    school: "",
  });

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [searchedValueParent, setSearchedValueParent] =
    React.useState<IOnSearchUser>();
  const [searchedValueSchool, setSearchedValueSchool] =
    React.useState<IOnSearchUser>();
    const [expireDate, setExpireDate] = useState<string>(props.service?.expire);

    useEffect(()=>{
      setExpireDate(props.service?.expire)
    },[props.service?.expire])


  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  const formik = useFormik<IUpdateStudent>({
    enableReinitialize: true,
    initialValues: {
      ...props.service?.student,
      price: props.service?.price,
      expire:props.service?.expire
    },
    validationSchema: Yup.object({
      lastName: validations.yupValidations.lastName,
      firstName: validations.yupValidations.firstName,
      // nationalCode: validations.yupValidations.nationalCode,
      price: validations.yupValidations.price,
    }),
    onSubmit: async (values: IUpdateStudent, { setSubmitting }) => {
      console.log({expireDate})
      const formValues: any = {
        serviceId: props.service._id,
        studentFirstName: values.firstName,
        studentLastName: values.lastName,
        price: convertPriceToNumber(values.price as string),
        parent: selectedParent._id,
        school: selectedSchool._id,
        startService: utils.convertNumbers2English(expireDate)
      };
      const updatedService = await driverUpdateService(formValues);
      if (updatedService?.CODE === 2099) {
        successHandler(2099);
      } else {
        errorHandler(5099);
      }
      props.allService.refetch()
      props.onClose()
    },
  });

  const submitHandler = () => {
    formik.submitForm();
  };

  const getAllSchool = useQuery(
    [values.useQueryKeys.getAllSchool, searchedValueSchool?.searchedValue],
    () =>
      api.post.common.findSchoolPost({
        search: {
          base: searchedValueSchool?.base?.value,
          value: searchedValueSchool?.searchedValue,
        },
        filters:{isApproved:true}
      })
  );
  let getAllParent: any;
  const getAllParentForAdmin = useQuery(
    [values.useQueryKeys.getAllParent, searchedValueParent],
    () =>
      api.post.administrator.getAllParent({
        search: {
          base: searchedValueParent?.base?.value,
          value: searchedValueParent?.searchedValue,
        },
      }),
    { enabled: userType === "ADMIN" }
  );
  const getAllParentForCompany = useQuery(
    [values.useQueryKeys.getAllParent, searchedValueParent],
    () =>
      api.post.common.findParent({
        search: {
          base: searchedValueParent?.base?.value,
          value: searchedValueParent?.searchedValue,
        },
      }),
    { enabled: userType === "COMPANY" }
  );
  getAllParent =
    userType === "ADMIN" ? getAllParentForAdmin : getAllParentForCompany;

  const AllParentWithCompleteName = getAllParent?.data?.result?.map(
    (item: any) => {
      return {
        ...item,
        completeName: item.firstName + " " + item.lastName,
      };
    }
  );

  const [selectedParent, setSelectedParen] = useState<any>(
    AllParentWithCompleteName?.find(
      (item: any) => item?._id === props.service?.parent?._id
    )
  );
  const [selectedSchool, setSelectedSchool] = useState<any>(
    props.service?.school
  );

  useEffect(() => {
    setSelectedSchool(props.service?.school);
  }, [props.service?.school]);

  useEffect(() => {
    setSelectedParen(
      AllParentWithCompleteName?.find(
        (item: any) => item?._id === props.service?.parent?._id
      )
    );
  }, [props.service?.parent]);

  return (
    <CustomModal
      open={props.isOpen}
      onClose={props.onClose}
      label={"ویرایش سرویس"}
    >
      <form onSubmit={submitHandler}>
        <CustomView.Container className="create-form-content">
        <CustomView.Row className="form-row final-row">
            <CustomView.Column className="form-colum">
              <label className="form-label">{t("servicePrice")}</label>
              <CustomInput
                name="price"
                id="price"
                value={
                  utils.convertPriceToNumber(formik.values.price as string)
                    ? utils.convertNumberToPrice(
                        utils.convertPriceToNumber(
                          formik.values.price as string
                        )
                      )
                    : "0"                }
                onValueChange={formik.handleChange}
                formikProps={{ onBlur: formik.handleBlur }}
                error={formik.errors.price && formik.touched.price}
                errorText={formik.errors.price}
              />
            </CustomView.Column>
            <CustomView.Column className="form-colum dropdown">
          <label className="form-label">{t("serviceStartDate")}</label>
          <CustomTimePiker
            defaultValue={expireDate}
            onChange={(event) => setExpireDate(event)}
          />
          <div className="error">
            {dropDownErrors.expire !== "" && dropDownErrors.expire}
          </div>
        </CustomView.Column>

          </CustomView.Row>

          <CustomView.Row className="form-row">
            <CustomView.Column medium={6} className="form-colum">
              <CustomInput
                name="firstName"
                id="firstName"
                label="نام"
                value={formik.values.firstName}
                onValueChange={formik.handleChange}
                formikProps={{ onBlur: formik.handleBlur }}
                error={formik.errors.firstName && formik.touched.firstName}
                errorText={formik.errors.firstName}
              />
            </CustomView.Column>
            <CustomView.Column medium={6} className="form-colum">
              <CustomInput
                name="lastName"
                id="lastName"
                label="نام خانوادگی"
                value={formik.values.lastName}
                onValueChange={formik.handleChange}
                formikProps={{ onBlur: formik.handleBlur }}
                error={formik.errors.lastName && formik.touched.lastName}
                errorText={formik.errors.lastName}
              />
            </CustomView.Column>
          </CustomView.Row>

          <CustomView.Row className="form-row final-row">
            <CustomView.Column medium={6} className="form-colum dropdown">
              <label className="form-label">{t("school")}</label>
              <CustomDropdownMultiSearch
                isSearch
                baseSearch={values.dropdownBaseSearch.SCHOOL_BASE_SEARCH.map(
                  (item) => ({
                    ...item,
                    title: t(item.title),
                  })
                )}
                items={getAllSchool?.data?.result}
                itemName="name"
                onSelectItem={(event: ICompanyItem) => {
                  setSelectedSchool(event);
                  setDropDownErrors({ ...dropDownErrors, school: "" });
                }}
                defaultItem={selectedSchool}
                searchedValue={searchedValueSchool}
                setSearchedValue={setSearchedValueSchool}
                placeHolder={t("selectSchool")}
                isLoading={getAllSchool.isLoading}
                selectedBaseSearch={searchedValueSchool?.base?.value}
              />
              <div className="error">
                {dropDownErrors.school !== "" && dropDownErrors.school}
              </div>
            </CustomView.Column>
            <CustomView.Column medium={6} className="form-colum dropdown">
              <label className="form-label">{t("parent")}</label>
              <CustomDropdownMultiSearch
                isSearch
                baseSearch={values.dropdownBaseSearch.PARENT_BASE_SEARCH.map(
                  (item) => ({
                    ...item,
                    title: t(item.title),
                  })
                )}
                items={AllParentWithCompleteName}
                itemName="completeName"
                onSelectItem={(event: ICompanyItem) => {
                  setSelectedParen(event);
                  setDropDownErrors({ ...dropDownErrors, parent: "" });
                }}
                defaultItem={selectedParent}
                searchedValue={searchedValueParent}
                setSearchedValue={setSearchedValueParent}
                placeHolder={t("selectParent")}
                isLoading={getAllParent.isLoading}
                selectedBaseSearch={searchedValueParent?.base?.value}
              />
              <div className="error">
                {dropDownErrors.parent !== "" && dropDownErrors.parent}
              </div>
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row className="form-row">
            <CustomView.Column
              medium={6}
              className="form-colum submit-button-relation"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={props.onClose}
                title={t("cancel")}
                type="danger"
              />
            </CustomView.Column>
            <CustomView.Column
              medium={6}
              className="form-colum submit-button-relation"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={submitHandler}
                title={t("submit")}
              />
            </CustomView.Column>
          </CustomView.Row>
        </CustomView.Container>
      </form>
    </CustomModal>
  );
};

export default UpdateServicePrice;
